module.exports = __webpack_public_path__ + "img/16_69.f2e11ceb.png";